import React from "react";

import XPayPaymentWidget from "src/sections/payment/widgetPayment/XPayPaymentWidget";



export const WidgetPayment = ({ method, onClose, total, serviceFee,
    taxAmount, error, setError, setOpenCart, setIsDisabled, discount, appliedPromotion }) => {


return (
    <>
       <XPayPaymentWidget/>
    </>
);
};
